// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Note Action Button */
.btn-note-action {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 8px;
  background: white;
  border: 1px solid #3498db;
  color: #3498db;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btn-note-action:hover {
  background: #3498db;
  color: white;
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
  transform: translateY(-1px);
}

/* Note Modal Overlay */
.note-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.note-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: noteModalAppear 0.3s ease-out;
}

@keyframes noteModalAppear {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.note-modal-header {
  background: #3498db;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.note-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.note-close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
}

.note-modal-body {
  padding: 20px;
}

.note-lead-name {
  font-size: 14px;
  color: #2c3e50;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e2e8f0;
}

.note-modal-body label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #7f8c8d;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.note-modal-body textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.note-modal-body textarea:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15);
}

.note-modal-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #eaeded;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.note-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.note-btn-cancel {
  background: #bdc3c7;
  color: white;
}

.note-btn-cancel:hover {
  background: #95a5a6;
}

.note-btn-save {
  background: #3498db;
  color: white;
}

.note-btn-save:hover {
  background: #2980b9;
  box-shadow: 0 2px 6px rgba(52, 152, 219, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/NoteButton.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C","sourcesContent":["/* Note Action Button */\n.btn-note-action {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #3498db;\n  color: #3498db;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.btn-note-action:hover {\n  background: #3498db;\n  color: white;\n  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Note Modal Overlay */\n.note-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.note-modal-content {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: noteModalAppear 0.3s ease-out;\n}\n\n@keyframes noteModalAppear {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.note-modal-header {\n  background: #3498db;\n  color: white;\n  padding: 15px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.note-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.note-close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.note-modal-body {\n  padding: 20px;\n}\n\n.note-lead-name {\n  font-size: 14px;\n  color: #2c3e50;\n  margin: 0 0 15px 0;\n  padding-bottom: 10px;\n  border-bottom: 1px dashed #e2e8f0;\n}\n\n.note-modal-body label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #7f8c8d;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.note-modal-body textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 120px;\n  outline: none;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.note-modal-body textarea:focus {\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15);\n}\n\n.note-modal-footer {\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #eaeded;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.note-btn {\n  padding: 8px 18px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.note-btn-cancel {\n  background: #bdc3c7;\n  color: white;\n}\n\n.note-btn-cancel:hover {\n  background: #95a5a6;\n}\n\n.note-btn-save {\n  background: #3498db;\n  color: white;\n}\n\n.note-btn-save:hover {\n  background: #2980b9;\n  box-shadow: 0 2px 6px rgba(52, 152, 219, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
